import { Col, DatePicker, Form, Input, Row } from "antd";
import { AlmacenesEmpleadoSelect } from "../reusable/AlmacenesEmpleadoSelect";
import { useDispatch, useSelector } from "react-redux";
import { SearchFormUi, SelectUi, FilterBtn } from "../../ui";
import {
  DateFormats,
  FiltersSearch_Types,
} from "../../../types/typesConstants";
import { comprobanteMovimientoStartLoading } from "../../../actions/inventario";
import { TipoComprobanteMovimientoSelect } from "./TipoComprobanteMovimientoSelect";
import dayjs from "dayjs";
import { parseDateFormatBackEnd } from "../../../helpers/utils";

const initialValues = (data = null) => {
  const aFechaEmision = data?.fechaemision?.split("|") || null;
  return {
    tipofiltro: data?.tipofiltro || FiltersSearch_Types.FECHAEMISION,
    tipocomprobantemovimiento: data?.tipocomprobantemovimiento || null,
    fechaemision: data?.fechaemision
      ? [dayjs(aFechaEmision[0]), dayjs(aFechaEmision[1])]
      : [dayjs(), dayjs()],
    almacen: data?.almacen || null,
    comprobante: data?.comprobante || null,
  };
};
const _tipofiltro = [
  {
    value: FiltersSearch_Types.TIPOCOMPROBANTE,
    label: "TIPO COMPROBANTE",
  },
  {
    value: FiltersSearch_Types.FECHAEMISION,
    label: "FECHA EMISIÓN",
  },
  {
    value: FiltersSearch_Types.ALMACEN,
    label: "ALMACEN",
  },
  {
    value: FiltersSearch_Types.COMPROBANTE,
    label: "COMPROBANTE",
  },
];
export const MovimientoSearchForm = () => {
  const [form] = Form.useForm();
  const tipofiltro = Form.useWatch("tipofiltro", form);
  const dispatch = useDispatch();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const handleSubmit = (values) => {
    if (tipofiltro === FiltersSearch_Types.FECHAEMISION)
      values = {
        ...values,
        fechaemision: `${parseDateFormatBackEnd(
          values?.fechaemision?.[0],
        )}|${parseDateFormatBackEnd(values?.fechaemision?.[1])}`,
      };
    localStorage.setItem("SearhFormTable", JSON.stringify(values));
    dispatch(comprobanteMovimientoStartLoading({ ...values }));
  };
  return (
    <SearchFormUi
      name="FormSearchMovimientos"
      form={form}
      autoComplete="off"
      initialValues={initialValues(
        JSON.parse(localStorage.getItem("SearhFormTable")),
      )}
      handleSubmit={handleSubmit}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={16} md={12} lg={8} xl={6}>
          <Form.Item name="tipofiltro" label="Buscar por">
            <SelectUi data={_tipofiltro} />
          </Form.Item>
        </Col>
        {tipofiltro === FiltersSearch_Types.TIPOCOMPROBANTE && (
          <Col xs={24} sm={16} md={12} lg={8} xl={8}>
            <Form.Item
              name="tipocomprobantemovimiento"
              label="Tipo comprobante"
            >
              <TipoComprobanteMovimientoSelect
                placeholder="[-TODOS-]"
                allowClear
              />
            </Form.Item>
          </Col>
        )}
        {tipofiltro === FiltersSearch_Types.ALMACEN && (
          <Col xs={24} sm={16} md={12} lg={8} xl={8}>
            <Form.Item name="almacen" label="Almacén">
              <AlmacenesEmpleadoSelect
                placeholder="[-TODOS-]"
                allowClear
                empleado={activeEmpleado?.id}
              />
            </Form.Item>
          </Col>
        )}
        {tipofiltro === FiltersSearch_Types.FECHAEMISION && (
          <Col xs={24} sm={16} md={12} lg={8} xl={8}>
            <Form.Item
              name="fechaemision"
              label="Fecha emisión"
              rules={[
                {
                  required: FiltersSearch_Types.FECHAEMISION,
                  message: "La fecha de emisión es obligatorio",
                },
              ]}
            >
              <DatePicker.RangePicker format={DateFormats.frontend} />
            </Form.Item>
          </Col>
        )}
        {tipofiltro === FiltersSearch_Types.COMPROBANTE && (
          <Col xs={24} sm={16} md={12} lg={8} xl={8}>
            <Form.Item
              name="comprobante"
              label="Comprobante"
              rules={[
                {
                  required: tipofiltro === FiltersSearch_Types.COMPROBANTE,
                  message: "El comprobante es obligatorio",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        )}
        <Col xs={24} sm={8} md={12} lg={6} xl={6}>
          <Form.Item>
            <FilterBtn htmlType="submit" />
          </Form.Item>
        </Col>
      </Row>
    </SearchFormUi>
  );
};
